import React from 'react';
import PropTypes from 'prop-types';
import { Layout } from '@vertem-core/vertice-ds';

const { Content } = Layout;

const WrapperDefault = ({ children }) => (
  <Content>
    { children }
  </Content>
);

WrapperDefault.propTypes = {
  children: PropTypes.node.isRequired,
};

export default WrapperDefault;
